export default __webpack_public_path__ + "static/media/illustration_calendar.c308880b.png";